module.exports = __webpack_public_path__ + "static/media/colour-swatch.9c36ea7b.png";